import { SsoInterfaceSdk, WebInterfaceSdk } from '@byted-sdk/account-api'
import WebInterface from '@byted-sdk/account-api/dist/interface/web'
import SSOInterface from '@byted-sdk/account-api/dist/interface/sso'
import fetch from 'lib/decorated-fetch'
import cookie from 'cookie'
import { IUserData } from 'Components/store'

let ssoSDK: SSOInterface
let webSDK: WebInterface

const IS_DEV = process.env.NODE_ENV === "development"

export const aid = 1839

export const getSsoSDK = () => {
  if (!ssoSDK) {
    const isBOE = cookie.parse(document.cookie)?.is_boe === "true"
    ssoSDK = new SsoInterfaceSdk({
      aid,
      isOversea: false,
      isBoe: isBOE,
      region: 'cn',
      scope: 'sso',
      scene: 'normal',
      host: isBOE ? "http://sso-boe.toutiao.com" : "https://sso.toutiao.com",
      printLog: IS_DEV,
      appName: "懂车帝PC站",
    })
  }
  return ssoSDK
}

export const getWebSDK = () => {
  if (!webSDK) {
    const isBOE = cookie.parse(document.cookie)?.is_boe === "true"
    webSDK = new WebInterfaceSdk({
      aid,
      isOversea: false,
      isBoe: isBOE,
      region: 'cn',
      scope: 'web',
      scene: 'normal',
      // host: "https://sso.toutiao.com",
      printLog: IS_DEV,
      appName: "懂车帝PC站",
    })
  }
  return webSDK
}

export const checkLogin = async () => {
  const json = await fetch(`/passport/account/info?aid=${aid}`)

  if (json?.message !== "success") {
    throw Error(json?.prompts || json?.message)
  }

  return json?.data
}


export const fetchUserInfo = async () => {
  const json = await fetch(`/passport/account/info/v2?aid=${aid}`)

  if (json?.message !== "success") {
    throw Error(json?.prompts || json?.message)
  }

  const result = {} as IUserData

  if (json?.data) {
    const keys: (keyof IUserData)[] = ["gender", "name", "screen_name", "user_id", "user_type", "avatar_url", "mobile"]
    keys.forEach((key) => {
      result[key] = json.data[key]
    })
  }

  return result
}
